// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2srEZ","choiceBoxes":"toolbarselects_choiceBoxes__2vcKJ","simpleField":"toolbarselects_simpleField__3frPq"};